import React, { Component } from 'react'
import PropTypes from 'prop-types'
import content from 'pp-react-l10n'
import { css, before } from 'glamor'
import { Tabs, TabPanel } from '@paypalcorp/pp-react'
import { routeTo } from '../../../utils/routeHelper'
import { connect } from 'transfer/utils/p2p-connect'
import { getNavHeight } from 'transfer/utils/preview-utils'
import {
  isMoneyMovementTrmt,
  isCrossBorderTrmt,
} from '../../../../experiments/easeOfPaymentsFeatures'
import glamorous from 'glamorous'
import {
  SIZE_SMALL,
  smallAndSmaller,
  biggerThanSmall,
} from '../../../../lib/styles/media-queries'
import { ENV_TYPE } from '../../../../../../lib/constants'

const i18n = content('transfer/page/recipient')

const Content = glamorous.div(
  {
    marginTop: '20px',
    marginBottom: '5rem',
    position: 'relative',
  },
  ({ navHeight }) => ({
    top:
      navHeight === 96
        ? navHeight - 34 // Personal Account Header
        : navHeight - 67, // Business Account Header
    [smallAndSmaller]: {
      top: '-36px',
    },
  }),
  ({ noMenu = isMoneyMovementTrmt() }) => {
    if (noMenu) {
      return { top: 0, marginTop: 0 }
    }
    return {}
  }
)

class Tab extends Component {
  displayName: 'Tabs'

  state = {
    navHeight: 72,
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    selected: PropTypes.number.isRequired,
    panes: PropTypes.array,
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.element),
      PropTypes.element,
    ]),
    env: PropTypes.string,
  }

  mediaQueryListener = () => {
    this.setNavHeight()
  }

  componentDidMount = () => {
    this.setNavHeight() // Set nav height on mount

    // The merchant team dynamically changes merchant height depending
    // on the experience the user is in. They will fire this event on change.
    document.addEventListener('merchantHeaderMarginUpdate', this.setNavHeight)

    try {
      this.mediaQueryMatcher = window.matchMedia(`(max-width: ${SIZE_SMALL}px)`)
      if (this.mediaQueryMatcher.addEventListener) {
        this.mediaQueryMatcher.addEventListener(
          'change',
          this.mediaQueryListener
        )
      } else {
        this.mediaQueryMatcher.addListener(this.mediaQueryListener)
      }
    } catch (e) {
      // ignore old browsers that support neither match media interface
    }
  }

  componentWillUnmount = () => {
    document.removeEventListener(
      'merchantHeaderMarginUpdate',
      this.setNavHeight
    )

    try {
      if (this.mediaQueryMatcher.removeEventListener) {
        this.mediaQueryMatcher.removeEventListener(
          'change',
          this.mediaQueryListener
        )
      } else {
        this.mediaQueryMatcher.removeListener(this.mediaQueryListener)
      }
    } catch (e) {
      // ignore old browsers that support neither match media interface
    }
  }

  // Only dynamically change for merchant accounts
  setNavHeight = () => {
    this.setState({ navHeight: getNavHeight() })
  }

  _renderContent = () => {
    const { navHeight } = this.state
    return (
      <Content navHeight={navHeight}>
        {this.props.children[this.props.selected]}
      </Content>
    )
  }

  handleClick = (e, index) => {
    e.preventDefault()
    const pane = this.props.panes[index]
    if (typeof pane.onClickAction === 'function') {
      pane.onClickAction(this.props.dispatch)
    }
    routeTo(pane.path)
  }

  preloadComponent = pane => {
    if (pane.comp && pane.comp.preload) {
      pane.comp.preload()
    } else {
      return
    }
  }

  render() {
    const isUnderEopTrmt =
      isMoneyMovementTrmt() ||
      (isCrossBorderTrmt() && this.props.env === ENV_TYPE.INTERNATIONAL)
    const shouldShowNav = !isUnderEopTrmt

    return (
      <div>
        {shouldShowNav && (
          <Tabs
            name="secondary-nav-tabs"
            className={css(
              {
                position: 'fixed',
                top: this.state.navHeight,
                zIndex: 2,
                ' nav': {
                  boxShadow: 'none',
                  [biggerThanSmall]: {
                    margin: 0,
                  },
                }, // this should move to nav specific class, when we have time
                [smallAndSmaller]: {
                  position: 'relative',
                  top: 0,
                  backgroundColor: 'white',
                  boxShadow:
                    '0rem 0rem 0.5rem rgb(0 0 0 / 4%), 0rem 0.125rem 1.125rem rgb(0 0 0 / 10%)',
                },
              },
              before({
                content: '""',
                position: 'fixed',
                top: this.state.navHeight,
                left: 0,
                backgroundColor: 'white',
                width: 999999999,
                height: '6rem',
                boxShadow:
                  '0rem 0rem 0.5rem rgb(0 0 0 / 4%), 0rem 0.125rem 1.125rem rgb(0 0 0 / 10%)',
                [smallAndSmaller]: {
                  display: 'none',
                },
              })
            ).toString()}
            selectedTabIdx={this.props.selected}
            onClick={this.handleClick}
            tabs={this.props.panes.map((pane, index) => ({
              label: pane.label,
              panelId: `secondary-nav-tab-${index}`,
              onMouseOver: () => this.preloadComponent(pane),
              onFocus: () => this.preloadComponent(pane),
              ...(pane.onClickOverride && { onClick: pane.onClickOverride }),
              'data-nemo': pane.datanemo,
              'data-extra': JSON.stringify(pane.analytics.extra),
            }))}
            scrollLeftLabel={i18n('secondaryNav.scrollLeft')}
            scrollRightLabel={i18n('secondaryNav.scrollRight')}
          >
            {this.props.panes.map((pane, index) => (
              <TabPanel
                key={pane.type.feature}
                id={`secondary-nav-tab-${index}`}
                aria-hidden="true"
                tabIndex={-1}
              />
            ))}
          </Tabs>
        )}
        {this._renderContent()}
      </div>
    )
  }
}

export default connect(({ server }) => ({
  env: server.env,
}))(Tab)
